const rewrites = [
  {
    source: '/robots.txt',
    destination: '/api/robots',
  },
  {
    source: '/sitemap.xml',
    destination: '/api/sitemap',
  },
];

module.exports = rewrites;
